import axios from "axios";
import { CognitoService } from "../services/cognito-service";

const backend = axios.create({
  baseURL: process.env.REACT_APP_SERVICE_URL,
  headers: { "Content-Type": "application/json" },
});

backend.interceptors.request.use(async function (options) {
  if (options.headers) {
    let userSession = await CognitoService.getSession();
    if (!userSession) return options;
    if (userSession.getIdToken().getExpiration() <= Date.now() / 1000 - 3) {
      // the cognito package should have already checked this for us, but just in case
      // the token is expired or will be very soon, force a refresh if possible
      console.log(
        "refreshing token: ",
        userSession.getIdToken().getIssuedAt(),
        Date.now() / 1000 - 3
      );
      await new Promise((f) => setTimeout(f, 300));
      userSession = await CognitoService.getSession();
    }
    if (!userSession) return options;
    options.headers!["Authorization"] = userSession.getIdToken().getJwtToken();
  }

  return options;
});

backend.interceptors.response.use(
  async function (response) {
    if (response.status === 401) {
      const refreshToken = response.headers["x-refresh-token"];
      if (refreshToken) {
        await CognitoService.refreshToken();
        const userSession = await CognitoService.getSession();
        response.headers["Authorization"] = userSession!
          .getIdToken()
          .getJwtToken();
      }
    }
    return response;
  },
  async function (error) {
    const { response } = error;
    if (response.status === 401) {
      localStorage.clear();
      window.location.reload();
    }
    return error;
  }
);

export { backend };
